var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pictureInput",on:{"click":_vm.open}},[(_vm.value)?_c('div',{staticClass:"picture"},[_c('img',{attrs:{"src":_vm.value,"alt":"图片显示失败"}})]):_c('div',[_c('a-icon',{staticClass:"icon",attrs:{"type":"camera"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }